import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcBookingEventTable from '@bookings/components/tables/booking-event-table/booking-event-table.vue';

@Component({
  name: 'bpc-booking-event',
  components: {
    'bpc-booking-event-table': BpcBookingEventTable,
  },
})
export default class BookingEvent extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
